module.exports = __webpack_public_path__ + "static/media/cab-q36.3cf8329a.jpg";